import * as React from 'react';
import { ResponsiveContainer } from 'recharts';

import ChartContext from './ChartContext';
import type { ChartContainerProps } from './types';

export const ChartContainer = React.forwardRef<
  HTMLDivElement,
  ChartContainerProps
>(
  (
    {
      children,
      className,
      ariaLabel,
      config,
      aspect = 1,
      width = '100%',
      height = undefined,
      minWidth = 1,
      minHeight = 1,
      initialDimension = { width: 1, height: 1 },
    },
    ref,
  ) => {
    const localRef = React.useRef<HTMLDivElement>(null);
    React.useImperativeHandle(ref, () => localRef.current as HTMLDivElement);

    return (
      <ChartContext.Provider value={{ config: config || {} }}>
        <div
          data-slot='chart-container'
          ref={localRef}
          role={ariaLabel ? 'img' : undefined}
          aria-label={ariaLabel}
          className={className}
        >
          <ResponsiveContainer
            width={width}
            height={height}
            aspect={aspect}
            minWidth={minWidth}
            minHeight={minHeight}
            initialDimension={initialDimension}
          >
            {children}
          </ResponsiveContainer>
        </div>
      </ChartContext.Provider>
    );
  },
);

ChartContainer.displayName = 'ChartContainer';
